import { useMutation, useQuery } from '@apollo/client'
import { Container } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  AppSettingTokenStatusEnum,
  PaymentSpiAppId,
  SpiPaymentsPluginDocument,
  UpdateSpiPaymentsPluginDocument,
} from '../../../../generated/graphql'
import {
  AuthenticationDialog,
  AuthenticationDialogForm,
} from '../authentication/dialog'
import { AuthenticationSection } from '../authentication/section'

export const SettingsVippsMobilePayPage = () => {
  const { t } = useTranslation(['apps', 'shared'])

  const { data, loading: isLoading } = useQuery(SpiPaymentsPluginDocument, {
    variables: {
      pluginId: PaymentSpiAppId.VippsMobilePay,
    },
  })

  const [isAuthOpen, setAuthOpen] = useState(false)
  const isAuthConfigured = Boolean(
    data?.spiPaymentsSettings?.url &&
      data.spiPaymentsSettings?.token_status === AppSettingTokenStatusEnum.Set,
  )

  const [updateSettings] = useMutation(UpdateSpiPaymentsPluginDocument)

  const onAuthSubmit = async (formData: AuthenticationDialogForm) => {
    const { login, password } = formData

    await updateSettings({
      variables: {
        input: {
          url: login,
          token: password,
          id: PaymentSpiAppId.VippsMobilePay,
        },
      },
    })
  }

  return (
    <Container>
      <AuthenticationDialog
        open={isAuthOpen}
        onClose={() => setAuthOpen(false)}
        onSubmit={onAuthSubmit}
        defaultValues={{
          login: data?.spiPaymentsSettings.url,
        }}
        slotProps={{
          loginInput: {
            label: t('apps:vipps_mobilepay.url_label'),
            helperText: t('apps:vipps_mobilepay.url_helper'),
            rules: {
              https: (value) => {
                if (value && !value.startsWith('https://')) {
                  return t('apps:vipps_mobilepay.invalid_url')
                }
              },
            },
          },
          passwordInput: {
            label: t('apps:vipps_mobilepay.token_label'),
            helperText: t('apps:vipps_mobilepay.token_helper'),
          },
        }}
      />

      <AuthenticationSection
        isConfigured={isAuthConfigured}
        onClick={() => setAuthOpen(true)}
        isLoading={isLoading}
      />
    </Container>
  )
}
